// require('es6-promise').polyfill();
import axios from 'axios';
import Vue from 'vue';
import global from './global.vue';
// import store from '../../store'
import router from '../router';
import { Message, Loading } from 'element-ui';

export const Axios = axios.create({
  // baseURL: 'http://www.wfjksmart.com/xljk-health-server/server/',
  baseURL: global.BASE_URL,

  timeout: 360000000000
});

let loading;        //定义loading变量
function startLoading () {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}
function endLoading () {    //使用Element loading-close 方法
  loading.close();
}
//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0;
export function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}
//POST传参序列化(添加请求拦截器)
// 在发送请求之前做某件事
Axios.interceptors.request.use(config => {
  // showFullScreenLoading()
  // console.log(config,"config")
  if (config.method === 'post' && config.url == "login") {
    // JSON 转换为 FormData
    const formData = new FormData();
    Object.keys(config.data).forEach(key => formData.append(key, config.data[key]));
    config.data = formData;
  }

  if (localStorage.token) {
    config.headers['token'] = localStorage.token;
    Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

  }
  // console.log(localStorage.token);

  return config;
}, error => {
  return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(res => {
  //对响应数据做些事
  if (res.headers.authorization) {
    localStorage.token = res.headers.authorization;
  }
  if (res.data.code === 401 || res.data.code === 403 || res.data.code === 404) {
    // 401 说明 token 验证失败
    // 可以直接跳转到登录页面，重新登录获取 token
    // location.href = '/login'
    // Vue.cookie.delete('token');
    // endLoading()
    Message.error("请刷新重试！！！");
    // router.push('/login')
  }

  else if (res.data.code === 500) {
    // 服务器错误
    // do something
    // console.log(res,'14Promise')
    // endLoading()
    if (res.data.msg) {
      Message.error(res.data.msg);
    }
  }
  tryHideFullScreenLoading();
  return res;

}, error => {
  console.log(router);
  // endLoading()
  // Message.error("与服务断开连接!!")
  // console.log(error)
  // console.log(JSON.stringify(error).search("401")!= -1,121111)
  if (JSON.stringify(error).search("401") != -1) {
    Message.error("登录超时请重新登录");
    localStorage.clear();
    sessionStorage.clear();
    router.push('/login');
    location.reload();
  } else {
    Message.error("与服务断开连接");
  }

  // 返回 response 里的错误信息 

  return Promise.reject(error);
});
/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
Axios.adornUrl = (actionName) => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/proxyApi/' : window.SITE_CONFIG.baseUrl) + actionName;
};
export default Axios

